import { EpimsBaseEntityDto } from './epim-base.dto';
export class VerificationStatusDto extends EpimsBaseEntityDto {

    VerificationStatusId: string;

    VerificationStatusName: string;
    SubscriberId: string;
    SubscriptionUserId: string;
}